/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { DeploymentDto } from './deploymentDto';
import { RequestedShare } from './requestedShare';
import { GPSPosition } from './gPSPosition';


export interface AnimalExtendedDto { 
    id?: number;
    label?: string;
    role?: AnimalExtendedDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    colorRgbCode?: string;
    animalSex?: AnimalExtendedDto.AnimalSexEnum;
    creationTimestamp?: string;
    updateTimestamp?: string;
    deployments?: Array<DeploymentDto>;
    dateOfBirth?: string;
    dateOfDeath?: string;
    deathComment?: string;
    animalSpeciesId?: string;
    accessOnlyFromCollar?: boolean;
    lastPosition?: GPSPosition;
    distanceLastPosition?: number;
    positionCount?: number;
    lastReception?: string;
    lastReceptionDataEventType?: AnimalExtendedDto.LastReceptionDataEventTypeEnum;
    networkStatus?: AnimalExtendedDto.NetworkStatusEnum;
}
export namespace AnimalExtendedDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
    export const AnimalSexEnum = {
        Male: 'MALE',
        Female: 'FEMALE',
        Unknown: 'UNKNOWN'
    } as const;
    export type AnimalSexEnum = typeof AnimalSexEnum[keyof typeof AnimalSexEnum];
    export const LastReceptionDataEventTypeEnum = {
        Unknown: 'UNKNOWN',
        GpsPosition: 'GPS_POSITION',
        Separation: 'SEPARATION',
        TrapEvent: 'TRAP_EVENT',
        Proximity: 'PROXIMITY',
        Mortality: 'MORTALITY',
        MortalityImplant: 'MORTALITY_IMPLANT',
        VaginalImplant: 'VAGINAL_IMPLANT',
        Activity: 'ACTIVITY',
        GsmQuality: 'GSM_QUALITY',
        VirtualFence: 'VIRTUAL_FENCE',
        CollarLog: 'COLLAR_LOG'
    } as const;
    export type LastReceptionDataEventTypeEnum = typeof LastReceptionDataEventTypeEnum[keyof typeof LastReceptionDataEventTypeEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
}


export type LastReceptionDataEventTypeEnum = typeof AnimalExtendedDto.LastReceptionDataEventTypeEnum[keyof typeof AnimalExtendedDto.LastReceptionDataEventTypeEnum];
